import {Component, Input, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {User} from '@models/user/user';
import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {TranslateService} from '@ngx-translate/core';
import {takeUntil} from 'rxjs/operators';
import {ElasticSearchResponseEntity} from '@models/elastic-search/response/elastic-search-response-entity';
import {ElasticSearchResult} from '@models/elastic-search/response/elastic-search-result';
import {Subject} from 'rxjs';
import {MachineryGroupDetailsService} from '@services/administration/machine-group/machinery-group-details.service';

@Component({
    selector: 'scitis-admin-machine-group-users',
    templateUrl: './machine-group-users.component.html',
    styleUrls: ['./machine-group-users.component.scss'],
    standalone: false
})
export class MachineGroupUsersComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  users: User[] = new Array<User>();

  @Input()
  machineGroupName: string = '';
  @Input()
  machineGroupId: number | null = null;
  @Input()
  rootOrganizationId: number | null = null;
  @Input()
  whiteListedMachineryGroups: number[] | null = null;
  @Input()
  loggedUserId: string = '';

  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  constructor(private tableHeaderSortableService: TableHeaderSortableService,
              public translate: TranslateService,
              private machineryGroupDetails: MachineryGroupDetailsService) {
  }

  ngOnDestroy(): void {

    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.users = this.tableHeaderSortableService.sortItems<User>(this.users, column, direction);
  }

  ngOnInit(): void {
    this.setUsers();
  }

  private setUsers() {
    this.machineryGroupDetails.listAssignedUsers(this.machineGroupId, this.whiteListedMachineryGroups)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (success: ElasticSearchResponseEntity) => {
        if (success?.result?.data && success.result.data.length > 0) {
          const result: ElasticSearchResult = success.result;
          this.users = result.data;
        }
      }, error: (error) => {
        console.log(error);
      }
    });
  }
}
